/**
 * Error utilities for handling API errors.
 */

interface AxiosErrorResponse {
  response?: {
    status?: number;
    data?: {
      detail?: {
        code?: string;
        message?: string;
      } | string;
    };
  };
}

/**
 * Check if an error indicates the user has no role assigned.
 * This happens when a user is authenticated via Okta but not in users.yml.
 */
export const isNoRoleError = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') {
    return false;
  }

  const axiosError = error as AxiosErrorResponse;
  const response = axiosError.response;

  if (!response) {
    return false;
  }

  // Check for 403 status with NO_ROLE_ASSIGNED code
  if (response.status === 403) {
    const detail = response.data?.detail;
    if (typeof detail === 'object' && detail?.code === 'NO_ROLE_ASSIGNED') {
      return true;
    }
  }

  return false;
};
